import ChatNewConversation from './styled';

export default ChatNewConversation;
